import React from 'react'

// A traditional closed dropdown for a multi-value field: collapsed to one
// line showing a summary of what's picked, opens into a checkbox list on
// click — unlike a native <select multiple>, which is always expanded and
// eats several lines of vertical space.
export default function CompactMultiSelect({label, VS, setVS, options}) {

    function toggleOption(option){
        let selected = VS[0].slice();
        if(selected.includes(option)){
            selected = selected.filter((o) => o !== option);
        }else{
            selected.push(option);
        }
        setVS([selected, (selected.length > 0)? 1 : -1]);
    }

    const selected = VS[0];
    const summary = (selected.length === 0)? "Select reasons"
        : (selected.length <= 2)? selected.join(', ')
        : selected.length + " reasons selected";

    return (
        <div className='inputDiv'>
            <span className='controlLabel iolx-label'
            style={{display: (label === '')? 'none' : null}}>{label}</span>
            <details className='iolx-compact-dropdown'>
                <summary className='formControl controlValid'>{summary}</summary>
                <div className='iolx-compact-dropdown-panel'>
                    {options.map((option) =>
                        <label key={option} className='iolx-compact-dropdown-option'>
                            <input type='checkbox'
                            checked={selected.includes(option)}
                            onChange={() => toggleOption(option)}/>
                            {option}
                        </label>
                    )}
                </div>
            </details>
        </div>
    )
}
